import { TableV2 } from '@anytag/shared-atoms';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { MarketplaceDetail, MarketplacePost } from '@anytag/graphql';
import { useUpdateMarketplacePostsStatus } from '../hooks';
import { ActionBar } from './ActionBar';
import { useMarketplacePostsListTable } from './hooks';

export interface TemplateProps {
  loading?: boolean;
  hasTrackingReferral?: boolean;
  marketplace: MarketplaceDetail;
  posts: readonly MarketplacePost[];
}

export const Template = ({ posts, loading, marketplace, hasTrackingReferral }: TemplateProps) => {
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const { UpdateMarketplacePostStatusModal } = useUpdateMarketplacePostsStatus({ marketplaceId: marketplace.id });
  const { columns, postsActions } = useMarketplacePostsListTable({
    posts,
    marketplace,
    hasTrackingReferral
  });

  return (
    <>
      <div className="relative">
        <TableV2
          ref={offsetRef}
          loading={loading}
          noTopBorderRadius
          maxHeight={defaultTableMaxHeight}
          data={posts}
          columns={columns}
          rowHeight="61px"
          stickyHeader
        />
        <ActionBar {...postsActions} marketplace={marketplace} />
      </div>

      <UpdateMarketplacePostStatusModal onSuccess={() => postsActions.setSelectedItemIds([])} />
    </>
  );
};
